function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "leoo1bnmca"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.373 4.73a.757.757 0 1 0-1.514 0v2.312a.757.757 0 0 0 1.514 0zm2.388 3.307a.754.754 0 1 0 1.07 1.063l1.62-1.62a.766.766 0 0 0-.008-1.07.757.757 0 0 0-1.062.008zM8.394 9.1a.754.754 0 1 0 1.07-1.062l-1.6-1.62a.774.774 0 0 0-1.07-.008.764.764 0 0 0 0 1.062zm10.223 10.561a.95.95 0 0 0 1.341 0 .964.964 0 0 0 0-1.341L12.8 11.126a.95.95 0 0 0-1.341 0 .972.972 0 0 0 0 1.341zM5.094 11.487a.753.753 0 1 0 0 1.507h2.32a.753.753 0 1 0 0-1.507zm15.037 1.507a.753.753 0 1 0 0-1.507h-2.313a.753.753 0 1 0 0 1.507zm-1.168 6.072-4.287-4.3.422-.422 4.294 4.3a.322.322 0 0 1 .053.482c-.145.136-.323.098-.482-.06zM6.782 16.994a.764.764 0 0 0-.015 1.062.776.776 0 0 0 1.077.015l1.612-1.612A.751.751 0 1 0 8.4 15.39zm6.592.452a.757.757 0 0 0-1.514 0v2.313a.757.757 0 1 0 1.514 0z",
  transform: "translate(-.62 -.567)"
});

function SvgMagicWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#leoo1bnmca)"
    }
  }, _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.d0694473.svg";
export { ForwardRef as ReactComponent };